import React from "react";
import { Button, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import AdvanceSearch from "./AdvanceSearch";
import {
  setModalStats,
  oppFetch,
  setSliderStatus,
  setIntersectionModalStats,
  setIntersectionInitialState,
} from "../../api/redux";
import IntersectionModal from "./IntersectionModal";
import { selectLicenseList } from "../../api/redux";
import IntersectionResultModal from "./IntersectionResultModal";
import config from "../../../../config/config";

export default (props) => {
  const dispatch = useDispatch();
  const state = useSelector(selectLicenseList);

  return (
    <div className="d-flex flex-wrap">
      <div className="col-12 col-md-6 h-3 my-2">
        <Button
          type="primary"
          className="w-100 h-100 primary-bg border border-white border-8 my-2"
          key={8}
          onClick={() => {
            props.submitHandler();
          }}
        >
          جست و جو
        </Button>
      </div>
      <div className="col-12 col-md-6 h-3 my-2">
        <Button
          key={9}
          className="w-100 h-100 bg-white border border-danger text-danger border-8 my-2"
          onClick={() => {
            props.clearHandler(props.func);
          }}
        >
          حذف فیلتر
        </Button>
      </div>
      <div className="col-12 h-3 my-2">
        <Button
          type="primary"
          className="w-100 h-100 primary-bg border border-white border-8"
          key={10}
          onClick={() => {
            dispatch(setModalStats(true));
          }}
        >
          جست و جوی پیشرفته
        </Button>
      </div>
      {config.isIntersectionAvailable && (
        <div className="col-12 h-3 my-2">
          <Button
            type="primary"
            className="w-100 h-100 primary-bg border border-white border-8"
            key={10}
            onClick={() => {
              dispatch(setIntersectionInitialState({ questions: {} }));
              dispatch(setIntersectionModalStats(true));
            }}
          >
            محاسبه محدودیت ها
          </Button>
        </div>
      )}
      {state.intersectionInitialState && <IntersectionModal />}
      <IntersectionResultModal />
      <AdvanceSearch />
    </div>
  );
};
